import React, { useContext } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Lozenge from '@atlaskit/lozenge/new/lozenge';

import { UserProfileCardContext } from '../../store/context';

const messages = defineMessages({
	accountDeactivated: {
		id: 'user-profile-card.DeactivatedStatus.accountDeactivated',
		defaultMessage: 'Account deactivated',
		description:
			'Status label shown on the profile card when the user account is inactive/deactivated',
	},
});

/**
 * Renders a status lozenge indicating that the user account has been deactivated. Shown in place of
 * the recent-work / manager sections when the profiled user is inactive.
 */
export function DeactivatedStatus(): React.JSX.Element {
	const intl = useIntl();
	const { getTestId } = useContext(UserProfileCardContext);

	return (
		<Lozenge appearance="neutral" testId={getTestId('account-status')}>
			{intl.formatMessage(messages.accountDeactivated)}
		</Lozenge>
	);
}
